module.exports = __webpack_public_path__ + "img/SurrealisticCinemaGraph.96bf6b30.gif";